import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ToolOutlined, SyncOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, PageHeader, Table, Layout } from 'antd';
import { apiClient, apiErrorMessage, hasPermission } from '../../../utils';
import { UserContext } from '../../contexts';
import { Equipment } from '../../../models';

const { Content } = Layout;
export function EquipmentsPage() {
  const { user } = useContext(UserContext);
  const [equipments, setEquipments] = useState<Equipment[]>();
  const [canEdit, setCanEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCanEdit(hasPermission(user, 'equipments.sync_sap'));
  }, [user]);

  const loadEquipments = useCallback(() => {
    setLoading(true);
    apiClient
      .get(`equipments`)
      .then((response: any) => {
        const responseEquipments: Equipment[] = response.data;
        const responseData = responseEquipments.map(equipment => {
          return {
            key: equipment.id,
            ...equipment,
          };
        });
        setEquipments(responseData);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  }, []);

  useEffect(() => {
    loadEquipments();
  }, [loadEquipments]);

  const onRefreshClick = () => {
    loadEquipments();
  };

  const onSyncClick = () => {};

  const tableColumns: any[] = [
    {
      title: 'Malzeme no',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Malzeme tanımı',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  return (
    <>
      <PageHeader
        title={
          <>
            <ToolOutlined /> Malzemeler
          </>
        }
        extra={[
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
          <>
            {canEdit && (
              <Button type="primary" key="sync" onClick={onSyncClick} icon={<SyncOutlined />}>
                SAP ile eşle
              </Button>
            )}
          </>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} dataSource={equipments} loading={loading} pagination={false} />
      </Content>
    </>
  );
}
